export const announcementData = {
  talk1: {
    type: "announcement",
    title: "Bus Route Change Notice",
    titleKr: "버스 노선 변경 안내",
    versions: {
      basic: {
        script: `Attention, passengers. This is an important announcement regarding Route 25 of the Metro City Bus Service. Due to ongoing construction work on Maple Street, <mark>buses on this route will be temporarily</mark> rerouted starting Monday, March 15th.
Instead of traveling along Maple Street, Route 25 will take Jefferson Avenue and Pine Road before rejoining its regular path. This change will remain in effect until the construction is completed, which is expected by the end of April.
<mark>We understand that many of you are used to taking this route daily</mark>, but we kindly ask for your patience as we work to improve road conditions in the area. For more information, <mark>please visit our website, or check the updated schedule at any bus stop along the affected route</mark>. Thank you for your understanding.`,
        translation: `승객 여러분께 안내 말씀드립니다. 메트로 시티 버스 서비스 25번 노선과 관련하여 중요한 공지사항이 있습니다. 메이플 스트리트의 진행 중인 공사로 인해, 이 노선의 버스들은 3월 15일 월요일부터 임시로 경로가 변경될 예정입니다.
메이플 스트리트 대신, 25번 노선은 제퍼슨 애비뉴와 파인 로드를 지난 후 정규 경로로 합류할 예정입니다. 이 변경은 4월 말까지 완료될 것으로 예상되는 공사가 끝날 때까지 유지됩니다.
많은 분들이 이 노선을 매일 이용하고 계신다는 점을 잘 알고 있습니다만, 이 지역의 도로 상태를 개선하는 동안 양해를 부탁드립니다. 자세한 정보는 저희 웹사이트 www.MetroCityBus.com을 방문하시거나, 해당 노선의 모든 버스 정류장에서 업데이트된 시간표를 확인하실 수 있습니다. 이해해 주셔서 감사합니다.`,
        audioUrl: {
          us: "audios/part4/announcement/us/us1.mp3",
          uk: "audios/part4/announcement/uk/uk1.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the announcement about?",
        questionKr: "이 안내방송은 무엇에 관한 것입니까?",
        options: {
          A: "A <mark>new bus route</mark> introduction",
          B: "A <mark>temporary route</mark> change",
          C: "A <mark>bus fare</mark> increase",
          D: "An <mark>additional bus</mark> service",
        },
        optionsKr: {
          A: "새로운 버스 노선 도입",
          B: "임시 노선 변경",
          C: "버스 요금 인상",
          D: "추가 버스 서비스",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 새로운 버스 노선 도입
B: 임시 노선 변경
C: 버스 요금 인상
D: 추가 버스 서비스

정답 B: 스크립트의 "buses on this route will be temporarily rerouted"에서 임시 노선 변경임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          'What does the speaker mean when he says, "<mark>We understand that many of you are used to taking this route daily</mark>"?',
        questionKr:
          '"We understand that many of you are used to taking this route daily"라고 말한 의도는 무엇입니까?',
        options: {
          A: "The change will <mark>affect many</mark> passengers",
          B: "The bus will <mark>no longer</mark> operate",
          C: "The route is being <mark>permanently removed</mark>",
          D: "Only a <mark>small number</mark> of passengers use this route",
        },
        optionsKr: {
          A: "이 변경이 많은 승객들에게 영향을 미칠 것이다",
          B: "버스가 더 이상 운행하지 않을 것이다",
          C: "노선이 영구적으로 폐지된다",
          D: "소수의 승객만이 이 노선을 이용한다",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 이 변경이 많은 승객들에게 영향을 미칠 것이다
B: 버스가 더 이상 운행하지 않을 것이다
C: 노선이 영구적으로 폐지된다
D: 소수의 승객만이 이 노선을 이용한다

정답 A: 스크립트의 "many of you are used to taking this route daily"에서 많은 승객들이 이 노선을 정기적으로 이용하고 있어 변경이 영향을 미칠 것임을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What does the speaker suggest the listeners do?",
        questionKr: "연사는 청취자들에게 무엇을 제안합니까?",
        options: {
          A: "Visit the <mark>website</mark> for more details",
          B: "Take a <mark>different bus</mark> <mark>route</mark>",
          C: "Purchase tickets in <mark>advance</mark>",
          D: "Contact the <mark>city government</mark>",
        },
        optionsKr: {
          A: "자세한 내용을 위해 웹사이트 방문하기",
          B: "다른 버스 노선 이용하기",
          C: "사전에 티켓 구매하기",
          D: "시 정부에 연락하기",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 자세한 내용을 위해 웹사이트 방문하기
B: 다른 버스 노선 이용하기
C: 사전에 티켓 구매하기
D: 시 정부에 연락하기

정답 A: 스크립트의 "For more information, please visit our website"에서 자세한 정보를 위해 웹사이트를 방문하라고 제안하고 있음을 알 수 있습니다.`,
      },
    ],
  },
  talk2: {
    type: "announcement",
    title: "Flight Delay Notice",
    titleKr: "항공편 지연 안내",
    versions: {
      basic: {
        script: `Attention, passengers. This is an important announcement regarding Flight NX562 to New York. <mark>Due to unexpected mechanical issues, this flight has been delayed for safety reasons</mark>. The original departure time of 4:15 P.M. has now been rescheduled to 7:45 P.M..
We sincerely apologize for the inconvenience and appreciate your patience. <mark>Passengers are advised to remain in the terminal and wait for further updates</mark>. Complimentary meal vouchers will be provided at Gate 12 for all ticketed passengers.
<mark>If you have any urgent travel concerns, please visit the airline service desk near Gate 10</mark>. Thank you for your understanding.`,
        translation: `승객 여러분께 안내 말씀드립니다. 뉴욕행 NX562편과 관련하여 중요한 공지사항이 있습니다. 예상치 못한 기계적 문제로 인해 이 항공편이 안전상의 이유로 지연되었습니다. 원래 오후 4시 15분이었던 출발 시각이 오후 7시 45분으로 변경되었습니다.
불편을 끼쳐 진심으로 사과드리며, 양해해 주셔서 감사합니다. 승객 여러분께서는 터미널에 머무시면서 추가 안내를 기다려 주시기 바랍니다. 12번 게이트에서 모든 티켓 소지 승객분들께 식사 바우처를 제공해 드립니다.
긴급한 여행 관련 문의사항이 있으신 분들은 10번 게이트 근처의 항공사 서비스 데스크를 방문해 주시기 바랍니다. 이해해 주셔서 감사합니다.`,
        audioUrl: {
          us: "audios/part4/announcement/us/us2.mp3",
          uk: "audios/part4/announcement/uk/uk2.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is being announced?",
        questionKr: "무엇이 안내되고 있습니까?",
        options: {
          A: "A <mark>flight delay</mark>",
          B: "A change in airline <mark>policy</mark>",
          C: "A <mark>gate reassignment</mark>",
          D: "A <mark>baggage delay</mark>",
        },
        optionsKr: {
          A: "항공편 지연",
          B: "항공사 정책 변경",
          C: "게이트 재배정",
          D: "수하물 지연",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 항공편 지연
B: 항공사 정책 변경
C: 게이트 재배정
D: 수하물 지연

정답 A: 스크립트의 "this flight has been delayed for safety reasons"에서 항공편이 지연되었음을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "What are passengers instructed to do <mark>during the delay</mark>?",
        questionKr: "승객들은 지연 동안 무엇을 하라고 지시받았습니까?",
        options: {
          A: "Stay within the <mark>terminal</mark>",
          B: "Leave the <mark>airport terminal</mark>",
          C: "Proceed to a <mark>different gate</mark>",
          D: "<mark>Check in</mark> again",
        },
        optionsKr: {
          A: "터미널 내에 머무르기",
          B: "공항 터미널을 떠나기",
          C: "다른 게이트로 이동하기",
          D: "다시 체크인하기",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
      A: 터미널 내에 머무르기
      B: 공항 터미널을 떠나기
      C: 다른 게이트로 이동하기
      D: 다시 체크인하기
      
      정답 A: 스크립트의 "Passengers are advised to remain in the terminal"에서 승객들이 터미널에 머물러야 한다고 지시받았음을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What does the speaker suggest for passengers with <mark>urgent travel concerns</mark>?",
        questionKr:
          "연사는 긴급한 여행 문제가 있는 승객들에게 무엇을 제안합니까?",
        options: {
          A: "Proceed to <mark>Gate 12</mark>",
          B: "Wait for further <mark>announcements</mark>",
          C: "Visit the airline <mark>service desk</mark>",
          D: "Contact their <mark>travel agency</mark>",
        },
        optionsKr: {
          A: "12번 게이트로 이동하기",
          B: "추가 안내를 기다리기",
          C: "항공사 서비스 데스크 방문하기",
          D: "여행사에 연락하기",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
      A: 12번 게이트로 이동하기
      B: 추가 안내를 기다리기
      C: 항공사 서비스 데스크 방문하기
      D: 여행사에 연락하기
      
      정답 C: 스크립트의 "If you have any urgent travel concerns, please visit the airline service desk near Gate 10"에서 긴급한 여행 문제가 있는 승객들에게 항공사 서비스 데스크를 방문하라고 제안하고 있음을 알 수 있습니다.`,
      },
    ],
  },
  talk3: {
    type: "announcement",
    title: "Passenger Search Announcement",
    titleKr: "승객 수색 안내",
    versions: {
      basic: {
        script: `Attention, passengers. This is an urgent announcement from Oceanic Airlines. We are <mark>looking for Mr. Jonathan Reeves</mark>, a passenger scheduled to board Flight OA719 to London.
Mr. Reeves, if you can hear this message, please proceed immediately to Gate 22, as your flight is ready for departure. Your final boarding call has been made, and the gate will close in five minutes.
For security reasons, all passengers must be on board before the final check is completed. If you fail to arrive at the gate on time, <mark>your seat will be reassigned</mark>, and your checked baggage may be removed from the aircraft.
If you require assistance or need to reschedule your flight, please <mark>visit the Oceanic Airlines service</mark> desk near Gate 10. Thank you for your cooperation.`,
        translation: `승객 여러분께 안내 말씀드립니다. 오세아닉 항공에서 긴급 안내드립니다. 런던행 OA719편 탑승 예정인 조나단 리브스 승객분을 찾고 있습니다.
리브스 님, 이 방송이 들리신다면 항공기가 곧 출발할 예정이오니 즉시 22번 게이트로 와주시기 바랍니다. 마지막 탑승 안내가 이미 있었으며, 게이트는 5분 후에 닫힐 예정입니다.
보안상의 이유로, 모든 승객은 최종 점검이 완료되기 전에 탑승을 마쳐야 합니다. 정시에 게이트에 도착하지 않으시면, 좌석이 다른 승객에게 배정되며, 위탁 수하물도 항공기에서 내려질 수 있습니다.
도움이 필요하시거나 항공편을 다시 예약하셔야 하는 경우, 10번 게이트 근처의 오세아닉 항공 서비스 데스크를 방문해 주시기 바랍니다. 협조해 주셔서 감사합니다.`,
        audioUrl: {
          us: "audios/part4/announcement/us/us3.mp3",
          uk: "audios/part4/announcement/uk/uk3.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "Who is this announcement intended for?",
        questionKr: "이 안내방송은 누구를 위한 것입니까?",
        options: {
          A: "Passengers waiting for a <mark>delayed flight</mark>",
          B: "Airport <mark>security</mark> <mark>officers</mark>",
          C: "A <mark>specific traveler</mark>",
          D: "A <mark>group</mark> of <mark>travelers</mark>",
        },
        optionsKr: {
          A: "지연된 항공편을 기다리는 승객들",
          B: "공항 보안 요원들",
          C: "특정 여행객",
          D: "여행객 그룹",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 지연된 항공편을 기다리는 승객들
B: 공항 보안 요원들
C: 특정 여행객
D: 여행객 그룹

정답 C: 스크립트의 "We are looking for Mr. Jonathan Reeves"에서 특정 승객을 찾고 있음을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          'What does the speaker mean when they say, "<mark>Your seat</mark> <mark>will</mark> <mark>be</mark> <mark>reassigned</mark>"?',
        questionKr:
          '"Your seat will be reassigned"라고 말한 의도는 무엇입니까?',
        options: {
          A: "The flight has been <mark>delayed</mark>",
          B: "The passenger <mark>may lose his seat</mark> if he does not arrive soon",
          C: "The airline is offering a <mark>free upgrade</mark>",
          D: "The flight is <mark>overbooked</mark>",
        },
        optionsKr: {
          A: "항공편이 지연되었다",
          B: "승객이 곧 도착하지 않으면 좌석을 잃을 수 있다",
          C: "항공사가 무료 업그레이드를 제공한다",
          D: "항공편이 초과 예약되었다",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 항공편이 지연되었다
B: 승객이 곧 도착하지 않으면 좌석을 잃을 수 있다
C: 항공사가 무료 업그레이드를 제공한다
D: 항공편이 초과 예약되었다

정답 B: 스크립트의 "If you fail to arrive at the gate on time, your seat will be reassigned"에서 제시간에 도착하지 않으면 좌석을 잃을 수 있다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What does the speaker suggest passengers do if they need help or need to reschedule?",
        questionKr:
          "연사는 도움이 필요하거나 일정을 변경해야 하는 승객들에게 무엇을 제안합니까?",
        options: {
          A: "Proceed to the <mark>airline's service desk</mark>",
          B: "Contact their <mark>travel agency</mark>",
          C: "<mark>Wait</mark> for another flight <mark>announcement</mark>",
          D: "<mark>Move</mark> to a <mark>different gate</mark>",
        },
        optionsKr: {
          A: "항공사 서비스 데스크로 가기",
          B: "여행사에 연락하기",
          C: "다른 항공편 안내를 기다리기",
          D: "다른 게이트로 이동하기",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
      A: 항공사 서비스 데스크로 가기
      B: 여행사에 연락하기
      C: 다른 항공편 안내를 기다리기
      D: 다른 게이트로 이동하기
      
      정답 A: 스크립트의 "If you require assistance or need to reschedule your flight, please visit the Oceanic Airlines service desk"에서 도움이 필요하거나 일정을 변경해야 하는 경우 서비스 데스크를 방문하라고 제안하고 있음을 알 수 있습니다.`,
      },
    ],
  },
  talk4: {
    title: "Shopping Mall Announcement: Weekend Sales Event",
    titleKr: "쇼핑몰 안내방송: 주말 세일 행사",
    type: "announcement",
    versions: {
      basic: {
        script: `Attention, shoppers! Welcome to Riverside Mall. We are excited to announce our <mark>Weekend Super Sale</mark>, happening today and tomorrow.
All stores on the first and second floors are offering up to 50% off selected items, including clothing, electronics, and home goods. In addition, there will be a special <mark>prize giveaway at 3 PM</mark> near the central fountain. Make sure to enter for a chance to win gift cards and exclusive discounts.
If you have any questions, <mark>please visit our customer service desk</mark> on the ground floor. Enjoy your shopping!`,
        translation: `쇼핑객 여러분! 리버사이드 몰에 오신 것을 환영합니다. 오늘과 내일 진행되는 주말 슈퍼 세일을 안내해 드리게 되어 기쁩니다.
1층과 2층의 모든 매장에서 의류, 전자제품, 생활용품을 포함한 선별된 상품을 최대 50% 할인된 가격에 제공합니다. 또한, 오후 3시에 중앙 분수대 근처에서 특별 경품 행사가 있을 예정입니다. 상품권과 특별 할인 혜택을 받을 수 있는 기회를 놓치지 마세요.
문의사항이 있으시면 1층의 고객 서비스 데스크를 방문해 주시기 바랍니다. 즐거운 쇼핑 되세요!`,
        audioUrl: {
          us: "audios/part4/announcement/us/us4.mp3",
          uk: "audios/part4/announcement/uk/uk4.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the purpose of the announcement?",
        questionKr: "이 안내방송의 목적은 무엇입니까?",
        options: {
          A: "To promote a <mark>sales event</mark> at a shopping mall",
          B: "To introduce a <mark>new</mark> <mark>store</mark> <mark>opening</mark>",
          C: "To inform customers of a <mark>parking</mark> <mark>policy</mark> <mark>change</mark>",
          D: "To provide details about a <mark>store</mark> <mark>relocation</mark>",
        },
        optionsKr: {
          A: "쇼핑몰의 세일 행사 홍보",
          B: "새로운 매장 오픈 소개",
          C: "주차 정책 변경 안내",
          D: "매장 이전에 대한 세부사항 제공",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 쇼핑몰의 세일 행사 홍보
B: 새로운 매장 오픈 소개
C: 주차 정책 변경 안내
D: 매장 이전에 대한 세부사항 제공

정답 A: 스크립트의 "We are excited to announce our Weekend Super Sale"에서 쇼핑몰의 주말 세일 행사를 홍보하는 것임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What will take place at <mark>3 PM</mark>?",
        questionKr: "오후 3시에 무엇이 진행됩니까?",
        options: {
          A: "A live performance by a <mark>local</mark> <mark>band</mark>",
          B: "A special <mark>prize</mark> <mark>giveaway</mark>",
          C: "A product demonstration at an <mark>electronics</mark> <mark>store</mark>",
          D: "A fashion show on the <mark>second</mark> <mark>floor</mark>",
        },
        optionsKr: {
          A: "지역 밴드의 라이브 공연",
          B: "특별 경품 증정 행사",
          C: "전자제품 매장의 제품 시연",
          D: "2층에서의 패션쇼",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 지역 밴드의 라이브 공연
B: 특별 경품 증정 행사
C: 전자제품 매장의 제품 시연
D: 2층에서의 패션쇼

정답 B: 스크립트의 "there will be a special prize giveaway at 3 PM"에서 오후 3시에 특별 경품 증정 행사가 있음을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "Where can shoppers <mark>get more information</mark>?",
        questionKr: "쇼핑객들은 어디에서 더 자세한 정보를 얻을 수 있습니까?",
        options: {
          A: "At the <mark>security</mark> <mark>office</mark>",
          B: "At the <mark>customer</mark> <mark>service</mark> <mark>desk</mark>",
          C: "At the <mark>central</mark> <mark>fountain</mark>",
          D: "<mark>Near the exit</mark> doors",
        },
        optionsKr: {
          A: "보안 사무실",
          B: "고객 서비스 데스크",
          C: "중앙 분수대",
          D: "출구 근처",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 보안 사무실
B: 고객 서비스 데스크
C: 중앙 분수대
D: 출구 근처

정답 B: 스크립트의 "please visit our customer service desk on the ground floor"에서 1층의 고객 서비스 데스크를 방문하라고 안내하고 있습니다.`,
      },
    ],
  },

  talk5: {
    type: "announcement",
    title: "Movie Theater Announcement",
    titleKr: "영화관 안내",
    versions: {
      basic: {
        script: `Attention, movie fans! <mark>Galaxy Theater will host a special midnight screening series next month</mark>. <mark>Starting August 5, classic science fiction films will be shown every Friday at 11:59 PM in our main auditorium</mark>. Tickets can be reserved online or at the box office.
We have <mark>partnered with the National Film Archive</mark> to present restored versions of each feature. Concession stands will remain open throughout the screenings to serve themed snacks and beverages.
<mark>For ticket details and the full schedule, please visit our website</mark> or contact customer service. Join us for an unforgettable cinematic experience under the stars!`,

        translation: `영화 팬 여러분께 알립니다! Galaxy Theater에서는 다음 달 특별 심야 상영회를 개최합니다. 8월 5일부터 매주 금요일 밤 11시 59분에 주강당에서 클래식 공상과학 영화를 상영합니다. 예매는 온라인 또는 매표소에서 가능합니다.
국립영화보관소와 협력하여 복원된 버전을 선보입니다. 스낵과 음료를 판매하는 매점은 상영 내내 운영됩니다.
티켓 정보와 전체 일정은 웹사이트를 방문하거나 고객 서비스로 문의해 주세요. 별빛 아래 잊을 수 없는 영화 경험에 여러분을 초대합니다!`,
        audioUrl: {
          us: "audios/part4/announcement/us/us5.mp3",
          uk: "audios/part4/announcement/uk/uk5.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is being announced?",
        questionKr: "공지의 주요 내용은 무엇인가?",
        options: {
          A: "A film <mark>festival</mark>",
          B: "A <mark>midnight</mark> <mark>screening</mark> series",
          C: "A special <mark>effects</mark> <mark>workshop</mark>",
          D: "A theater <mark>renovation</mark>",
        },
        optionsKr: {
          A: "영화제 개최",
          B: "심야 상영회 시리즈",
          C: "특수 효과 워크숍",
          D: "극장 보수 공사",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 영화제 개최
B: 심야 상영회 시리즈
C: 특수 효과 워크숍
D: 극장 보수 공사

정답 B: 스크립트의 "Galaxy Theater will host a special midnight screening series next month"에서 심야 상영회 시리즈를 개최한다는 것을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "Where will the films be shown?",
        questionKr: "영화는 어디에서 상영되는가?",
        options: {
          A: "<mark>Outdoor</mark> amphitheater",
          B: "<mark>Main</mark> <mark>auditorium</mark>",
          C: "<mark>Lobby</mark> screen",
          D: "<mark>Rooftop</mark> terrace",
        },
        optionsKr: {
          A: "야외 원형극장",
          B: "주강당",
          C: "로비 스크린",
          D: "옥상 테라스",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 야외 원형극장
B: 주강당
C: 로비 스크린
D: 옥상 테라스

정답 B: 스크립트의 "classic science fiction films will be shown every Friday at 11:59 PM in our main auditorium"에서 영화가 주강당에서 상영된다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "Which partnership is mentioned?",
        questionKr: "어떤 협력이 언급되었는가?",
        options: {
          A: "<mark>Local</mark> university",
          B: "<mark>National</mark> <mark>Film</mark> <mark>Archive</mark>",
          C: "Film <mark>critics</mark> association",
          D: "<mark>Cinematography</mark> school",
        },
        optionsKr: {
          A: "지역 대학",
          B: "국립영화보관소",
          C: "영화 평론가 협회",
          D: "영화 촬영 학교",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 지역 대학
B: 국립영화보관소
C: 영화 평론가 협회
D: 영화 촬영 학교

정답 B: 스크립트의 "We have partnered with the National Film Archive"에서 국립영화보관소와 협력했다는 것을 알 수 있습니다.`,
      },
    ],
  },

  talk6: {
    type: "announcement",
    title: "Office Maintenance Notice",
    titleKr: "사무실 유지보수 안내",
    versions: {
      basic: {
        script: `Attention, all employees. This is an important announcement from the Facilities Management Department.
On Friday, August 12th, we will be conducting a <mark>scheduled maintenance</mark> check on the building's air conditioning system. The inspection will begin at 8:00 A.M. and continue until 4:00 P.M. During this period, the <mark>air conditioning units will be turned off</mark> temporarily, and some areas of the building may experience higher indoor temperatures.
Employees <mark>are encouraged to use designated cooling zones</mark> located on the first and third floors if needed. If you have any concerns or require additional assistance, please contact the Facilities Management Office at extension 1203.
Thank you for your cooperation and understanding.`,
        translation: `직원 여러분께 안내 말씀드립니다. 시설 관리부에서 중요한 안내를 드립니다.
8월 12일 금요일에 건물의 공조 시스템에 대한 예정된 유지보수 점검을 실시할 예정입니다. 점검은 오전 8시에 시작하여 오후 4시까지 진행됩니다. 이 기간 동안 에어컨이 일시적으로 중단되며, 건물의 일부 구역에서 실내 온도가 평소보다 높아질 수 있습니다.
필요한 경우 1층과 3층에 위치한 지정 냉방 구역을 이용하시기 바랍니다. 문의사항이나 추가 지원이 필요하신 경우 내선 1203번으로 시설 관리실에 연락해 주시기 바랍니다.
협조해 주셔서 감사합니다.`,
        audioUrl: {
          us: "audios/part4/announcement/us/us6.mp3",
          uk: "audios/part4/announcement/uk/uk6.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the announcement mainly about?",
        questionKr: "이 안내방송은 주로 무엇에 관한 것입니까?",
        options: {
          A: "A change in office <mark>working</mark> <mark>hours</mark>",
          B: "An <mark>upcoming</mark> <mark>maintenance</mark> check",
          C: "A <mark>relocation</mark> of office departments",
          D: "A <mark>new</mark> company <mark>policy</mark>",
        },
        optionsKr: {
          A: "사무실 근무 시간 변경",
          B: "예정된 유지보수 점검",
          C: "사무실 부서 이전",
          D: "새로운 회사 정책",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 사무실 근무 시간 변경
B: 예정된 유지보수 점검
C: 사무실 부서 이전
D: 새로운 회사 정책

정답 B: 스크립트의 "we will be conducting a scheduled maintenance check on the building's air conditioning system"에서 건물의 공조 시스템 유지보수 점검이 예정되어 있음을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "What does the speaker say about the <mark>air conditioning system</mark>?",
        questionKr: "연사는 에어컨 시스템에 대해 무엇이라고 말합니까?",
        options: {
          A: "It will be <mark>turned off</mark> temporarily",
          B: "It will be completely <mark>replaced</mark>",
          C: "It will be upgraded with a <mark>new model</mark>",
          D: "It will operate at a <mark>lower temperature</mark>",
        },
        optionsKr: {
          A: "일시적으로 중단될 것이다",
          B: "완전히 교체될 것이다",
          C: "새 모델로 업그레이드될 것이다",
          D: "평소보다 낮은 온도로 작동할 것이다",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 일시적으로 중단될 것이다
B: 완전히 교체될 것이다
C: 새 모델로 업그레이드될 것이다
D: 평소보다 낮은 온도로 작동할 것이다

정답 A: 스크립트의 "the air conditioning units will be turned off temporarily"에서 에어컨이 일시적으로 중단될 것임을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What does the speaker suggest employees do?",
        questionKr: "연사는 직원들에게 무엇을 제안합니까?",
        options: {
          A: "<mark>Work from home</mark> for the day",
          B: "Use designated <mark>cooling</mark> <mark>areas</mark>",
          C: "Adjust the office <mark>lighting</mark>",
          D: "Bring <mark>personal air conditioning</mark> units",
        },
        optionsKr: {
          A: "당일 재택근무하기",
          B: "지정된 냉방 구역 이용하기",
          C: "사무실 조명 조정하기",
          D: "개인용 에어컨 가져오기",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 당일 재택근무하기
B: 지정된 냉방 구역 이용하기
C: 사무실 조명 조정하기
D: 개인용 에어컨 가져오기

정답 B: 스크립트의 "Employees are encouraged to use designated cooling zones"에서 직원들에게 지정된 냉방 구역을 이용하도록 제안하고 있음을 알 수 있습니다.`,
      },
    ],
  },
  talk7: {
    title: "Airport Announcement: Boarding Gate Change for Flight 782",
    titleKr: "공항 안내방송: 782편 탑승구 변경",
    type: "announcement",
    versions: {
      basic: {
        script: `Attention, passengers of Flight 782 to Los Angeles. This is an important announcement regarding your <mark>boarding gate</mark>.
Due to operational reasons, your flight will <mark>now depart from Gate 26 instead of Gate 14</mark>. Boarding will begin at 3:45 PM, as originally scheduled. Passengers <mark>should proceed to the new gate</mark> as soon as possible.
For further assistance, please visit the <mark>airline service counter near the departure area</mark>. We apologize for the inconvenience and appreciate your cooperation.`,
        translation: `로스앤젤레스행 782편 승객 여러분께 안내 말씀드립니다. 탑승구와 관련하여 중요한 공지사항이 있습니다.
운영상의 이유로 항공편이 14번 게이트가 아닌 26번 게이트에서 출발하게 되었습니다. 탑승은 원래 예정대로 오후 3시 45분에 시작됩니다. 승객 여러분께서는 가능한 한 빨리 새로운 게이트로 이동해 주시기 바랍니다.
추가 도움이 필요하시면 출발장 근처의 항공사 서비스 카운터를 방문해 주시기 바랍니다. 불편을 끼쳐 죄송합니다. 협조해 주셔서 감사합니다.`,
        audioUrl: {
          us: "audios/part4/announcement/us/us7.mp3",
          uk: "audios/part4/announcement/uk/uk7.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the purpose of this announcement?",
        questionKr: "이 안내방송의 목적은 무엇입니까?",
        options: {
          A: "To inform passengers of a <mark>flight</mark> <mark>delay</mark>",
          B: "To announce a weather-related <mark>cancellation</mark>",
          C: "To notify passengers of a <mark>gate</mark><mark>change</mark>",
          D: "To explain a baggage <mark>policy</mark> <mark>update</mark>",
        },
        optionsKr: {
          A: "항공편 지연 안내",
          B: "기상 관련 결항 공지",
          C: "탑승구 변경 안내",
          D: "수하물 정책 업데이트 설명",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 항공편 지연 안내
B: 기상 관련 결항 공지
C: 탑승구 변경 안내
D: 수하물 정책 업데이트 설명

정답 C: 스크립트의 "your flight will now depart from Gate 26 instead of Gate 14"에서 탑승구 변경에 대한 안내임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What should <mark>passengers</mark> do next?",
        questionKr: "승객들은 다음으로 무엇을 해야 합니까?",
        options: {
          A: "Confirm their flight details at the <mark>check-in</mark> <mark>counter</mark>",
          B: "Wait for further instructions at their <mark>current</mark> <mark>gate</mark>",
          C: "Go to <mark>Gate 26</mark> for boarding",
          D: "Collect their baggage at the <mark>claim</mark> <mark>area</mark>",
        },
        optionsKr: {
          A: "체크인 카운터에서 항공편 정보 확인하기",
          B: "현재 게이트에서 추가 지시 기다리기",
          C: "탑승을 위해 26번 게이트로 이동하기",
          D: "수하물 찾는 곳에서 짐 찾기",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 체크인 카운터에서 항공편 정보 확인하기
B: 현재 게이트에서 추가 지시 기다리기
C: 탑승을 위해 26번 게이트로 이동하기
D: 수하물 찾는 곳에서 짐 찾기

정답 C: 스크립트의 "Passengers should proceed to the new gate as soon as possible"에서 승객들이 새로운 게이트(26번)로 이동해야 함을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "Where can passengers get more information?",
        questionKr: "승객들은 어디에서 더 자세한 정보를 얻을 수 있습니까?",
        options: {
          A: "At the security <mark>checkpoint</mark>",
          B: "At the airline <mark>service counter</mark>",
          C: "At the <mark>information</mark><mark>desk</mark>",
          D: "At the <mark>arrival</mark><mark>gate</mark>",
        },
        optionsKr: {
          A: "보안 검색대",
          B: "항공사 서비스 카운터",
          C: "안내 데스크",
          D: "도착 게이트",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
      A: 보안 검색대
      B: 항공사 서비스 카운터
      C: 안내 데스크
      D: 도착 게이트
      
      정답 B: 스크립트의 "please visit the airline service counter near the departure area"에서 항공사 서비스 카운터에서 추가 정보를 얻을 수 있음을 알 수 있습니다.`,
      },
    ],
  },
  talk8: {
    type: "announcement",
    title: "Fire Drill Notice",
    titleKr: "소방 훈련 안내",
    versions: {
      basic: {
        script: `Attention, employees. This is an important announcement from the Safety and Security Department.
As part of our annual fire safety program, we will be conducting a mandatory fire drill on Thursday, <mark>March 21st, at 10:00 A.M.</mark> <mark>When the alarm sounds, all employees must immediately stop working and proceed to the nearest emergency exit.</mark>
Once outside, please assemble in your designated safety zones in the parking lot, where safety officers will conduct a headcount. This drill is expected to last approximately 20 minutes, and participation is required for all employees.
To ensure everyone is familiar with the emergency procedures, <mark>we have sent detailed fire evacuation guidelines via email. Please review them carefully before the drill.</mark> If you have any questions, please contact the Safety Office at extension 309.
Thank you for your cooperation.`,
        translation: `직원 여러분께 안내 말씀드립니다. 안전보안부에서 중요한 안내를 드립니다.
연례 화재 안전 프로그램의 일환으로, 3월 21일 목요일 오전 10시에 필수 소방 훈련을 실시할 예정입니다. 경보가 울리면 모든 직원은 즉시 업무를 중단하고 가장 가까운 비상구로 이동해야 합니다.
밖으로 나오면 주차장의 지정된 안전 구역에 모여주시기 바랍니다. 안전 담당관이 인원 점검을 실시할 예정입니다. 이 훈련은 약 20분 정도 소요될 예정이며, 모든 직원의 참여가 필수입니다.
모든 직원이 비상 절차를 숙지할 수 있도록 자세한 화재 대피 지침을 이메일로 발송했습니다. 훈련 전에 주의 깊게 검토해 주시기 바랍니다. 문의사항이 있으시면 내선 309번으로 안전실에 연락해 주시기 바랍니다.
협조해 주셔서 감사합니다.`,
        audioUrl: {
          us: "audios/part4/announcement/us/us8.mp3",
          uk: "audios/part4/announcement/uk/uk8.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the announcement mainly about?",
        questionKr: "이 안내방송은 주로 무엇에 관한 것입니까?",
        options: {
          A: "An office <mark>renovation</mark>",
          B: "A mandatory <mark>fire drill</mark>",
          C: "A change in company <mark>policy</mark>",
          D: "A workplace <mark>safety inspection</mark>",
        },
        optionsKr: {
          A: "사무실 개조",
          B: "필수 소방 훈련",
          C: "회사 정책 변경",
          D: "직장 안전 점검",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 사무실 개조
B: 필수 소방 훈련
C: 회사 정책 변경
D: 직장 안전 점검

정답 B: 스크립트의 "we will be conducting a mandatory fire drill"에서 필수 소방 훈련을 실시할 것임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "What does the speaker instruct employees to do <mark>when the alarm sounds</mark>?",
        questionKr: "연사는 경보가 울리면 직원들에게 무엇을 하라고 지시합니까?",
        options: {
          A: "Gather their <mark>belongings</mark> before leaving",
          B: "<mark>Evacuate</mark> the building <mark>immediately</mark>",
          C: "Call the <mark>fire department</mark>",
          D: "<mark>Wait</mark> for further instructions",
        },
        optionsKr: {
          A: "떠나기 전에 소지품을 챙기기",
          B: "즉시 건물에서 대피하기",
          C: "소방서에 전화하기",
          D: "추가 지시를 기다리기",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 떠나기 전에 소지품을 챙기기
B: 즉시 건물에서 대피하기
C: 소방서에 전화하기
D: 추가 지시를 기다리기

정답 B: 스크립트의 "immediately stop working and proceed to the nearest emergency exit"에서 즉시 대피해야 함을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What does the speaker ask employees to do <mark>before the drill</mark>?",
        questionKr: "연사는 훈련 전에 직원들에게 무엇을 하라고 요청합니까?",
        options: {
          A: "Sign an <mark>emergency preparedness form</mark>",
          B: "Review the <mark>evacuation</mark> <mark>guidelines</mark>",
          C: "Practice using a <mark>fire</mark> <mark>extinguisher</mark>",
          D: "Check in with their <mark>supervisors</mark>",
        },
        optionsKr: {
          A: "비상 대비 양식에 서명하기",
          B: "대피 지침 검토하기",
          C: "소화기 사용 연습하기",
          D: "감독관에게 보고하기",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 비상 대비 양식에 서명하기
B: 대피 지침 검토하기
C: 소화기 사용 연습하기
D: 감독관에게 보고하기

정답 B: 스크립트의 "Please review them (fire evacuation guidelines) carefully before the drill"에서 훈련 전에 대피 지침을 검토해야 함을 알 수 있습니다.`,
      },
    ],
  },
  talk9: {
    title: "Subway Service Update",
    titleKr: "지하철 운행 안내",
    type: "announcement",
    versions: {
      basic: {
        script: `Attention, passengers. This is an important announcement regarding subway service on Line 2.
Due to maintenance work, all trains between Central Station and Oakwood Station <mark>will be temporarily suspended from 10 PM tonight until 5 AM tomorrow</mark>. <mark>Passengers traveling to Oakwood Station are advised to take the shuttle bus service</mark>, which will operate every 15 minutes during this period.
<mark>For more information or assistance, please visit the station help desk or</mark> check our website. We apologize for the inconvenience and appreciate your understanding.`,
        translation: `승객 여러분께 안내 말씀드립니다. 2호선 지하철 운행과 관련하여 중요한 공지사항이 있습니다.
유지보수 작업으로 인해 오늘 밤 10시부터 내일 오전 5시까지 센트럴 역과 오크우드 역 사이의 모든 열차 운행이 일시적으로 중단됩니다. 오크우드 역으로 가시는 승객분들께서는 이 기간 동안 15분 간격으로 운행되는 셔틀버스 서비스를 이용해 주시기 바랍니다.
자세한 정보나 도움이 필요하시면 역사 안내 데스크를 방문하시거나 저희 웹사이트를 확인해 주시기 바랍니다. 불편을 끼쳐 죄송합니다. 양해해 주셔서 감사합니다.`,
        audioUrl: {
          us: "audios/part4/announcement/us/us9.mp3",
          uk: "audios/part4/announcement/uk/uk9.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the announcement mainly about?",
        questionKr: "이 안내방송은 주로 무엇에 관한 것입니까?",
        options: {
          A: "A <mark>new subway station</mark> opening",
          B: "A delay due to <mark>bad</mark> <mark>weather</mark>",
          C: "A <mark>temporary</mark> subway service <mark>suspension</mark>",
          D: "A <mark>schedule change</mark> for express trains",
        },
        optionsKr: {
          A: "새로운 지하철역 개통",
          B: "악천후로 인한 지연",
          C: "임시 지하철 운행 중단",
          D: "급행열차 시간표 변경",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 새로운 지하철역 개통
B: 악천후로 인한 지연
C: 임시 지하철 운행 중단
D: 급행열차 시간표 변경

정답 C: 스크립트의 "all trains between Central Station and Oakwood Station will be temporarily suspended"에서 임시 지하철 운행 중단에 대한 안내임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What <mark>alternative transportation</mark> is available?",
        questionKr: "어떤 대체 교통수단이 제공됩니까?",
        options: {
          A: "A <mark>free taxi</mark> service",
          B: "A <mark>special discount on train</mark> fares",
          C: "A shuttle bus running <mark>every 15</mark> <mark>minutes</mark>",
          D: "A transfer to <mark>another</mark> subway <mark>line</mark>",
        },
        optionsKr: {
          A: "무료 택시 서비스",
          B: "열차 요금 특별 할인",
          C: "15분 간격으로 운행되는 셔틀버스",
          D: "다른 지하철 노선으로의 환승",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 무료 택시 서비스
B: 열차 요금 특별 할인
C: 15분 간격으로 운행되는 셔틀버스
D: 다른 지하철 노선으로의 환승

정답 C: 스크립트의 "take the shuttle bus service, which will operate every 15 minutes"에서 15분 간격으로 운행되는 셔틀버스가 제공됨을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "Where can passengers get <mark>more information</mark>?",
        questionKr: "승객들은 어디에서 더 자세한 정보를 얻을 수 있습니까?",
        options: {
          A: "At the <mark>ticket</mark> <mark>counter</mark>",
          B: "At the station <mark>help</mark> <mark>desk</mark>",
          C: "On the subway's <mark>social media</mark> page",
          D: "From train <mark>conductors</mark>",
        },
        optionsKr: {
          A: "매표소",
          B: "역사 안내 데스크",
          C: "지하철 소셜 미디어 페이지",
          D: "열차 승무원",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 매표소
B: 역사 안내 데스크
C: 지하철 소셜 미디어 페이지
D: 열차 승무원

정답 B: 스크립트의 "please visit the station help desk or check our website"에서 역사 안내 데스크에서 정보를 얻을 수 있음을 알 수 있습니다.`,
      },
    ],
  },

  talk10: {
    title: "Tech Expo 2024 Opening Ceremony",
    titleKr: "테크 엑스포 2024 개막식",
    type: "announcement",
    versions: {
      basic: {
        script: `Good morning, everyone, and welcome to Tech Expo 2024. My name is Sarah Thompson, and I'm one of the <mark>event coordinators</mark>.
The <mark>opening ceremony</mark> will begin at 10 AM in the <mark>Grand Conference</mark> Hall, followed by keynote speeches from leading technology experts. After that, you can explore various exhibition booths showcasing the latest innovations in AI, robotics, and green energy.
Please remember that <mark>lunch will be provided at the main dining area from 12 PM to 1:30 PM</mark>. If you have any questions, visit the information desk near the entrance. We hope you enjoy the event!`,
        translation: `안녕하세요 여러분, 테크 엑스포 2024에 오신 것을 환영합니다. 제 이름은 사라 톰슨이고, 행사 코디네이터 중 한 명입니다.
개막식은 오전 10시에 그랜드 컨퍼런스홀에서 시작되며, 이어서 주요 기술 전문가들의 기조연설이 있을 예정입니다. 그 후에는 AI, 로봇공학, 친환경 에너지 분야의 최신 혁신을 선보이는 다양한 전시 부스들을 둘러보실 수 있습니다.
점심 식사는 오후 12시부터 1시 30분까지 메인 식당에서 제공될 예정이니 기억해 주시기 바랍니다. 문의사항이 있으시면 입구 근처의 안내 데스크를 방문해 주시기 바랍니다. 행사 즐겁게 보내시기 바랍니다!`,
        audioUrl: {
          us: "audios/part4/announcement/us/us10.mp3",
          uk: "audios/part4/announcement/uk/uk10.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the purpose of the announcement?",
        questionKr: "이 안내방송의 목적은 무엇입니까?",
        options: {
          A: "To introduce a <mark>new</mark> <mark>technology</mark> <mark>product</mark>",
          B: "To provide information about an <mark>event</mark>",
          C: "To inform participants of a <mark>schedule</mark> <mark>change</mark>",
          D: "To invite people to a business <mark>meeting</mark>",
        },
        optionsKr: {
          A: "새로운 기술 제품 소개",
          B: "행사에 대한 정보 제공",
          C: "일정 변경 사항 안내",
          D: "비즈니스 미팅 초대",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 새로운 기술 제품 소개
B: 행사에 대한 정보 제공
C: 일정 변경 사항 안내
D: 비즈니스 미팅 초대

정답 B: 스크립트의 "welcome to Tech Expo 2024"와 이어지는 행사 일정 안내를 통해 행사에 대한 정보를 제공하는 것이 목적임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "Where will the <mark>opening ceremony</mark> take place?",
        questionKr: "개막식은 어디에서 열립니까?",
        options: {
          A: "At the <mark>Grand</mark> <mark>Conference</mark> <mark>Hall</mark>",
          B: "In the <mark>exhibition</mark> area",
          C: "At the <mark>main dining</mark> area",
          D: "Near the <mark>entrance</mark>",
        },
        optionsKr: {
          A: "그랜드 컨퍼런스홀",
          B: "전시 구역",
          C: "메인 식당",
          D: "입구 근처",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 그랜드 컨퍼런스홀
B: 전시 구역
C: 메인 식당
D: 입구 근처

정답 A: 스크립트의 "The opening ceremony will begin at 10 AM in the Grand Conference Hall"에서 개막식이 그랜드 컨퍼런스홀에서 열림을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What is mentioned about <mark>lunch</mark>?",
        questionKr: "점심 식사에 대해 어떤 내용이 언급되었습니까?",
        options: {
          A: "It will be served from <mark>12 PM to 1:30</mark> PM",
          B: "Participants need to bring their own <mark>meals</mark>",
          C: "It will only be available for <mark>VIP</mark> guests",
          D: "<mark>Reservations</mark> are required in <mark>advance</mark>",
        },
        optionsKr: {
          A: "오후 12시부터 1시 30분까지 제공된다",
          B: "참가자들이 직접 식사를 준비해야 한다",
          C: "VIP 손님들에게만 제공된다",
          D: "사전 예약이 필요하다",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 오후 12시부터 1시 30분까지 제공된다
B: 참가자들이 직접 식사를 준비해야 한다
C: VIP 손님들에게만 제공된다
D: 사전 예약이 필요하다

정답 A: 스크립트의 "lunch will be provided at the main dining area from 12 PM to 1:30 PM"에서 점심이 오후 12시부터 1시 30분까지 제공됨을 알 수 있습니다.`,
      },
    ],
  },
  talk11: {
    title: "International Business Expo 2024",
    titleKr: "국제 비즈니스 엑스포 2024",
    type: "announcement",
    versions: {
      basic: {
        script: `Good morning, and welcome to the <mark>International Business Expo</mark> 2024. My name is Emily Carter, and I am one of the event coordinators.
The <mark>opening session will begin at 9 AM</mark> in Hall A, where industry leaders will discuss the future of global trade. After that, attendees can explore over 200 exhibition booths, featuring the latest business solutions, financial services, and technology trends.
For those interested in networking, there will be a business networking session at 3 PM in Conference Room B. If you need assistance, <mark>visit our help desk near the main entrance</mark>. We hope you have a productive day at the expo!`,
        translation: `안녕하세요, 국제 비즈니스 엑스포 2024에 오신 것을 환영합니다. 제 이름은 에밀리 카터이고, 행사 코디네이터 중 한 명입니다.
개막 세션은 오전 9시에 A홀에서 시작되며, 업계 리더들이 글로벌 무역의 미래에 대해 논의할 예정입니다. 그 후에는 최신 비즈니스 솔루션, 금융 서비스, 기술 트렌드를 선보이는 200개 이상의 전시 부스를 둘러보실 수 있습니다.
네트워킹에 관심이 있으신 분들을 위해 오후 3시에 컨퍼런스룸 B에서 비즈니스 네트워킹 세션이 있을 예정입니다. 도움이 필요하시면 메인 입구 근처의 안내 데스크를 방문해 주시기 바랍니다. 엑스포에서 유익한 시간 보내시기 바랍니다!`,
        audioUrl: {
          us: "audios/part4/announcement/us/us11.mp3",
          uk: "audios/part4/announcement/uk/uk11.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main topic of the announcement?",
        questionKr: "이 안내방송의 주요 주제는 무엇입니까?",
        options: {
          A: "A company's <mark>new</mark> <mark>product</mark> <mark>launch</mark>",
          B: "An upcoming <mark>business</mark> <mark>conference</mark>",
          C: "A schedule for a <mark>business</mark> <mark>expo</mark>",
          D: "A <mark>financial</mark> <mark>investment</mark> <mark>seminar</mark>",
        },
        optionsKr: {
          A: "기업의 신제품 출시",
          B: "예정된 비즈니스 컨퍼런스",
          C: "비즈니스 엑스포 일정",
          D: "금융 투자 세미나",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 기업의 신제품 출시
B: 예정된 비즈니스 컨퍼런스
C: 비즈니스 엑스포 일정
D: 금융 투자 세미나

정답 B: 스크립트의 "welcome to the International Business Expo 2024"와 전체적인 행사 일정 안내를 통해 비즈니스 컨퍼런스에 대한 안내임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What will take place at <mark>9 AM</mark>?",
        questionKr: "오전 9시에 무엇이 진행됩니까?",
        options: {
          A: "A <mark>networking</mark> <mark>event</mark>",
          B: "An <mark>exhibition booth</mark> presentation",
          C: "An <mark>opening session</mark> with industry leaders",
          D: "A workshop on <mark>financial</mark> <mark>technology</mark>",
        },
        optionsKr: {
          A: "네트워킹 행사",
          B: "전시 부스 발표",
          C: "업계 리더들과 함께하는 개막 세션",
          D: "금융 기술 워크숍",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 네트워킹 행사
B: 전시 부스 발표
C: 업계 리더들과 함께하는 개막 세션
D: 금융 기술 워크숍

정답 C: 스크립트의 "The opening session will begin at 9 AM in Hall A, where industry leaders will discuss"에서 오전 9시에 업계 리더들과 함께하는 개막 세션이 있음을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What event will take place in <mark>Conference Room B</mark>?",
        questionKr: "컨퍼런스룸 B에서 어떤 이벤트가 열릴 예정입니까?",
        options: {
          A: "A product <mark>demonstration</mark>",
          B: "A <mark>networking</mark> session",
          C: "A <mark>panel</mark> discussion",
          D: "A <mark>lunch</mark> break",
        },
        optionsKr: {
          A: "제품 시연회",
          B: "네트워킹 세션",
          C: "패널 토론",
          D: "점심 시간",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
      A: 제품 시연회
      B: 네트워킹 세션
      C: 패널 토론
      D: 점심 시간
      
      정답 B: 스크립트의 "For those interested in networking, there will be a business networking session at 3 PM in Conference Room B"에서 컨퍼런스룸 B에서 네트워킹 세션이 열릴 것임을 알 수 있습니다.`,
      },
    ],
  },
};
